import styled from 'styled-components';

export const StoreSectionLayout = styled.div`
  overflow: hidden;

  .column-app {
    padding: 0;
    background: #f2f2f2;
    text-align: center;
    display: flex;
    position: relative;
    height: 500px;

    .app-row {
      display: flex;
      align-items: center;

      .image-app {
        position: relative;
        width: 100%;
        max-width: 360px;
      }

      .description-row {
        text-align: left;
        position: absolute;
        top: 20%;
        left: 28vw;
        width: 100%;
        max-width: 450px;

        .app-icons {
          margin-top: 2.5rem;
        }

        p {
          margin-bottom: 1rem;
          font-size: 1.125rem;
          color: #666765;
        }

        a {
          margin-left: -0.5rem;
        }

        h2 {
          color: #c40023;
          margin-bottom: 1rem;
          font-size: 1.875rem;
          font-weight: bold;
          line-height: 37px;
        }
      }
    }

    .user-row {
      padding: 0;
    }

    .image-app-user {
      max-height: 100%;

      @media (min-width: 1500px) {
        position: absolute !important;
        right: 0px;
      }
    }

    .section-bar {
      position: absolute;
      bottom: 0;
    }
  }

  .main-button {
    &.info-section {
      margin: 10px auto !important;
    }
  }
  @media (max-width: 1200px) {
    .column-app {
      height: 400px;

      .image-app {
        max-width: 275px !important;
      }

      .app-row {
        .description-row {
          position: relative;
          top: 0;
          left: 0;

          h1 {
            line-height: 2.6rem;
          }

          .app-icons {
            margin-top: 1rem;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .column-app {
      display: grid;
      position: relative;
      background: linear-gradient(180deg, #ffffff 20%, #f2f2f2 20%);
      height: 100%;

      .app-row {
        display: grid;
        align-items: center;
        padding: 0;
        padding-top: 10px;

        .image-app {
          position: relative;
          width: 55% !important;
          margin: auto;
        }

        .description-row {
          text-align: center;
          position: relative;
          top: 0;
          left: 0;
          width: 60vw;
          margin: auto;

          .app-icons {
            margin: 2rem 0;
          }

          h1 {
            line-height: 1.6rem;
          }

          h1,
          p {
            margin-bottom: 1rem;
          }

          a {
            margin-right: 0.5rem;
          }
        }
      }

      .user-row {
        display: none;
      }

      .image-app-user {
        width: 100% !important;
      }
    }
  }

  @media (max-width: 420px) {
    .column-app {
      .app-row {
        .image-app {
          margin: auto;
        }

        .description-row {
          width: 90vw;
          margin: auto;

          .app-icons {
            display: block;
            margin: 2rem auto;
          }
        }
      }

      .image-app-user {
        height: 323px !important;
      }
    }
  }
`;
